import canUseDOM from "./canUseDOM";
import { getCanonicalSiteOrigin, parseAppOrigin } from "@/constants/site";

type RequestOriginSource = {
  headers?: {
    get(name: string): null | string;
  };
  url?: string;
};

const isLoopbackHost = (host: string): boolean => {
  const hostname = host
    .replace(/:\d+$/, "")
    .replace(/^\[|\]$/g, "")
    .toLowerCase();
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "::1"
  );
};

export const getServerSideURL = () => getCanonicalSiteOrigin();

/**
 * Origin of the incoming admin/API request.
 * Prefer Host / `x-forwarded-*` over canonical `serverURL` so local Next on
 * :3001 and Vercel custom domains are not captured against the wrong host.
 */
export const getRequestOriginURL = (
  req?: null | RequestOriginSource,
): string => {
  const headers = req?.headers;
  const forwardedHost = headers?.get("x-forwarded-host")?.split(",")[0]?.trim();
  const host = forwardedHost || headers?.get("host")?.trim();
  const forwardedProto = headers
    ?.get("x-forwarded-proto")
    ?.split(",")[0]
    ?.trim()
    ?.replace(/:$/, "");

  if (host) {
    const proto: "http" | "https" =
      forwardedProto === "http" || forwardedProto === "https"
        ? forwardedProto
        : isLoopbackHost(host)
          ? "http"
          : "https";
    return (
      parseAppOrigin(`${proto}://${host}`, proto) ?? getCanonicalSiteOrigin()
    );
  }

  if (typeof req?.url === "string" && req.url.length > 0) {
    const fromUrl = parseAppOrigin(req.url);
    if (fromUrl) return fromUrl;
  }

  return getCanonicalSiteOrigin();
};

export const getClientSideURL = () => {
  if (canUseDOM) {
    return (
      parseAppOrigin(window.location.origin) ?? getCanonicalSiteOrigin()
    );
  }

  return getCanonicalSiteOrigin();
};
